<template>
    <div class="intelligence-table">
        <h3 class="intelligence-table__title">
            {{ $t('pages.intelligence.provider_competition.charts.provider_table') }}
        </h3>
        <div v-if="providers.length" class="intelligence-table__wrapper">
            <table>
                <thead>
                    <tr>
                        <th>{{ $t('pages.intelligence.provider_competition.table.provider') }}</th>
                        <th>{{ $t('pages.intelligence.provider_competition.table.npi') }}</th>
                        <th>{{ $t('pages.intelligence.provider_competition.table.proposals') }}</th>
                        <th>{{ $t('pages.intelligence.provider_competition.table.avg_rank') }}</th>
                        <th>{{ $t('pages.intelligence.provider_competition.table.wins') }}</th>
                        <th>{{ $t('pages.intelligence.provider_competition.table.losses') }}</th>
                        <th>{{ $t('pages.intelligence.provider_competition.table.selection') }}</th>
                        <th>{{ $t('pages.intelligence.provider_competition.table.conversion') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in providers" :key="rowKey(row)">
                        <td>{{ row.displayName }}</td>
                        <td>{{ row.providerNpi || '—' }}</td>
                        <td>{{ row.proposals }}</td>
                        <td>{{ row.averageResponseRank }}</td>
                        <td>{{ row.wins }}</td>
                        <td>{{ row.losses }}</td>
                        <td>{{ formatPercent(row.selectionRate) }}</td>
                        <td>{{ formatPercent(row.conversionRate) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <p v-else class="intelligence-table__empty">{{ $t('pages.intelligence.provider_competition.empty') }}</p>
    </div>
</template>

<script>
    export default {
        props: {
            providers: {
                type: Array,
                default: () => [],
            },
        },

        methods: {
            rowKey(row) {
                return row.userId != null ? `user-${row.userId}` : `npi-${row.providerNpi}`
            },

            formatPercent(value) {
                if (value === null || value === undefined) return '—'
                return `${value}%`
            },
        },
    }
</script>

<style lang="scss" scoped>
    .intelligence-table {
        background: #fff;
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        padding: 20px;
    }

    .intelligence-table__title {
        margin: 0 0 16px;
        font-size: 16px;
        font-weight: 600;
        color: #111827;
    }

    .intelligence-table__wrapper {
        overflow-x: auto;
    }

    table {
        width: 100%;
        border-collapse: collapse;
        font-size: 14px;
    }

    th,
    td {
        padding: 12px 10px;
        text-align: left;
        border-bottom: 1px solid #e5e7eb;
    }

    th {
        color: #6b7280;
        font-weight: 600;
        font-size: 12px;
        text-transform: uppercase;
    }

    .intelligence-table__empty {
        margin: 0;
        color: #6b7280;
        font-size: 14px;
    }
</style>
